import Home from './components/Home.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

function beforeEnterFunction(to, _from, next) {
  // this should check for a logged in
  // if (session token exists) {
  //   next();
  // }
  // else {
  //   next('/login');
  // }
  next();
}

const router = new VueRouter({
  routes: [
    {
      name: 'home',
      path: '/home',
      component: Home,
      beforeEnter: beforeEnterFunction
    }, {
      name: 'stem',
      path: '/stem',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/customReports/StemMajors.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'datacollection',
      path: '/datacollection',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/academicaffairs/DataCollection.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'autoadmissions',
      path: '/reports/autoadmissions',
      component: () => import(/* webpackChunkName: "student" */ './components/AutoAdmissions.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallprograms',
      path: '/reports/smallprograms',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/SmallPrograms.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallclass',
      path: '/reports/smallclass',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/SmallClass.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'report',
      path: '/reports/:reportId',
      component: () => import(/* webpackChunkName: "reports" */ './components/Report.vue'),
      props: true,
      beforeEnter: beforeEnterFunction
    }, {
      name: 'aboutUs',
      path: '/aboutUs',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/AboutUs.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallprogramsd',
      path: '/datacollection/smallprogramsd',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/academicaffairs/smallprograms/SmallProgramsMain.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallcoursesections',
      path: '/datacollection/smallsections',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/academicaffairs/smallclass/SmallClassMain.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallsectionslist',
      path: '/datacollection/smallsections/list',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/academicaffairs/smallclass/SmallClassList.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallsectionsacccess',
      path: '/datacollection/smallsections/access',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/academicaffairs/smallclass/SmallClassAccessMaintenance.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallsectionscourse',
      path: '/datacollection/smallsections/:campus/:course',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/academicaffairs/smallclass/SmallClassCourse.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'smallsectionssummary',
      path: '/datacollection/smallsections/summary',
      component: () => import(/* webpackChunkName: "smallclass" */ './components/academicaffairs/smallclass/SmallClassSummary.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'p20adm',
      path: '/p20adm',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/customReports/P20Adm.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'community',
      path: '/community',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/Community.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'openData',
      path: '/openData',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/OpenData.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'flc',
      path: '/flc',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/FacultyFLC.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'freezeSchedule',
      path: '/freezeSchedule',
      component: () => import(/* webpackChunkName: "googleSheet" */ './components/GoogleSheet.vue'),
      props: {
        sheetId: 'freezeSchedule'
      },
      beforeEnter: beforeEnterFunction
    }, {
      name: 'reportDirectory',
      path: '/reports',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/ReportDirectory.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'trainingMaterials',
      path: '/trainingMaterials',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/TrainingMaterials.vue'),
      props: {
        sheetId: 'trainingMaterials'
      },
      beforeEnter: beforeEnterFunction
    }, {
      name: 'dataDictionary',
      path: '/dataDictionary',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/DataDictionary.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'mtvcomp',
      path: '/mtvcomp/:lookup',
      props: true,
      component: () => import(/* webpackChunkName: "irapodd" */ './components/dd/irapoDataDictionaryLookupTable.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'mtvcompList',
      path: '/mtvcomp',
      component: () => import(/* webpackChunkName: "irapodd" */ './components/dd/irapoDataDictionaryLookup.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'irodd',
      path: '/irodd/:reportId',
      props: true,
      component: () => import(/* webpackChunkName: "irapodd" */ './components/dd/irapoDataDictionaryTable.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'iroddList',
      path: '/irodd',
      component: () => import(/* webpackChunkName: "irapodd" */ './components/dd/irapoDataDictionary.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'odsdd',
      path: '/odsdd/:tableName',
      props: true,
      component: () => import(/* webpackChunkName: "odsdd" */ './components/dd/odsDataDictionaryTable.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'odsddList',
      path: '/odsdd',
      component: () => import(/* webpackChunkName: "odsdd" */ './components/dd/odsDataDictionary.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'reportingDefinitions',
      path: '/reportingDefinitions',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/ReportingDefinitions.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'mobile',
      path: '/mobile',
      component: () => import(/* webpackChunkName: "infoPages" */ './components/MobileMaps.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'adminDashboard',
      path: '/admin/dashboard',
      component: () => import(/* webpackChunkName: "admin" */ './components/AdminDashboard.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      name: 'adminReportCache',
      path: '/admin/reports/:reportId',
      props: true,
      component: () => import(/* webpackChunkName: "admin" */ './components/AdminReportCache.vue'),
      beforeEnter: beforeEnterFunction
    }, {
      path: '*',
      redirect: '/home'
    }
  ]
});

export default router;